import { DashboardMetricasView } from './dashboard-metricas.view'

function DashboardMetricas() {
  return (
    <DashboardMetricasView/>
  )
}

export { DashboardMetricas }
